<script lang="ts">
  import { renderMarkdown, renderMarkdownInline } from '$lib/utils/markdown';

  interface Props {
    source: string;
    inline?: boolean;
  }

  let { source, inline = false }: Props = $props();
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -- escape-first, see markdown.ts -->
{@html inline ? renderMarkdownInline(source) : renderMarkdown(source)}
